import { Grid } from '@material-ui/core';
import { useStyles } from '../../../GlobalRestitution/ValueCard/Podium/style';
import { meaningRankColors } from '../../Tests/Major/Result/content/meaningPresentation';

const CompassValuePodium = ({ results = [] }: { results?: any[] }) => {
  const classes = useStyles();
  const columns = [
    { rank: 1, barClass: classes.second },
    { rank: 0, barClass: classes.first },
    { rank: 2, barClass: classes.third },
  ];

  return (
    <>
      <div className={`${classes.root} ${classes.withBorder}`}>
        <Grid container={true} justifyContent="center" alignItems="flex-end">
          {columns.map(({ rank, barClass }) => (
            <Grid item={true} key={rank}>
              <div
                className={`${barClass} ${classes.contentPodium}`}
                style={{ background: meaningRankColors[rank] }}>
                {results[rank]?.score ?? 0}
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
      <div className={classes.root}>
        <Grid container={true} justifyContent="center" alignItems="flex-end">
          {columns.map(({ rank }) => (
            <Grid item={true} key={rank}>
              <div className={classes.titleContent}>
                {rank === 0 ? <b>{results[rank]?.label}</b> : results[rank]?.label}
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default CompassValuePodium;
